import React, { useState, useEffect, useRef } from 'react';
import './superxWinners.css'
import C2wCircleHightlightCrd from '../../../common/C2wHome/courseDetails/circleHightlightCrd';

function C2wSuperxWinners() {

  const [selectedIndex, setSelectedIndex] = useState(0)
  const arr = ['Java 2025', 'Flutter 2025']
  const [elementWidth, setElementWidth] = useState(0);
  const [activeObj, setActiveObj] = useState("https://www.youtube.com/embed/47gn9CXfG3k")
  const videoUrl = [
    "https://www.youtube.com/embed/47gn9CXfG3k",
    "https://www.youtube.com/embed/I-hkSsk7xVE",
    "https://www.youtube.com/embed/PNebti2x_fI",
    "https://www.youtube.com/embed/kkQ11faLfgA",
    "https://www.youtube.com/embed/4S-4UmZ195k",
  ]

  const imgArr = [
    "JavaWin1.jpeg",
    "JavaWin2.jpeg",
    "JavaWin3.jpeg",
    "JavaWin4.jpeg",
    "JavaWin5.jpeg",
  ]

  const handleIndex = (obj) => {
    setSelectedIndex(obj)
  }

  const [showPlayer, setShowPlayer] = useState(false)
  useEffect(() => {
    if (!activeObj) {
      setShowPlayer(false); // unmount first
      setTimeout(() => setShowPlayer(true), 50); // remount after 50ms
    }
  }, [activeObj]);


  const renderVideoPlayer = (activeObj) => {
    console.log(activeObj)
    if (!activeObj) return null;

    return (
      <>
        <iframe
          width="100%"
          height="100%"
          src={`${activeObj}?autoplay=1&mute=1&rel=0`}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" pl allowfullscreen></iframe>
      </>
    );
  };

  const handleVideoClick = (index) => {
    setActiveObj(index)
  };

  const elementRef = useRef(null);
  useEffect(() => {
    if (elementRef.current) {
      // Get the width of the referenced element
      setElementWidth(elementRef.current.offsetWidth);
    }

    const handleResize = () => {
      if (elementRef.current) {
        setElementWidth(elementRef.current.offsetWidth);
      }
    };

    // Add resize event listener
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const obj = [
    { title: "Groups participated in Super-X", count: "220+" },
    { title: "Winners", count: '5' }
  ]

  return (
    <div className='C2wCourseDemoLectures_ctn C2wCourseOfflineDemoLectures_ctn' ref={elementRef}>
      <div className='C2wCoureseDetailComponentHeading_ctn'>
        <div className='heading'>
          {`${''} `}
          <span className='headingSpan'>{`${'Projects developed by students under Super-X Platform'}`}</span>
        </div>
      </div>
      <div className='C2wCourseDemoLectures_crd_hld'>
        {obj && obj.map((obj, index) => (
          <C2wCircleHightlightCrd obj={obj} />
        ))}
      </div>
      <div className='C2wCourseDemoLecturesVideos_hld_ctn'>
        {elementWidth > 620 ?
          <div className='C2wDemoLecturevideoPlayer'>
            <>
              {renderVideoPlayer(activeObj)}
            </>

          </div> : null}
        <div className='C2wDemoLecturevideosList_ctn'>
          {videoUrl && videoUrl?.map((obj, index) => (
            <div className='C2wDemoLecturevideosList_crd' style={{
              backgroundImage: `url(/assets/images/offlineCourseDetail/${imgArr[index]})`
            }}
              onClick={() => {
                if (activeObj === obj) {
                  return
                }
                handleVideoClick(obj)
              }}>
              <div className='listPlayBtnDiv'>
                <svg width="25" height="32" viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M-0.00292969 1.97483C-0.00292969 0.536347 1.58843 -0.332454 2.79845 0.445417L23.9816 14.0632C25.0949 14.7789 25.0949 16.4063 23.9816 17.122L2.79845 30.7397C1.58843 31.5176 -0.00292969 30.6488 -0.00292969 29.2103V1.97483Z" fill="#05A5FF" />
                </svg>
              </div>
              {activeObj === obj ?
                <div className='INCSUBDemoLecture_crd_playing'>
                  Playing...</div> : null
              }
            </div>))}
        </div>

      </div>
      <>{activeObj && elementWidth < 621 ? <div className='C2w_video_show_popup_container'>
        <div className='C2wDemoLecturevideoPlayer mobile'>
          <div onClick={() => {
            setActiveObj(null)
          }}><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
              <path d="M18 6L6 18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M6 6L18 18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg></div>
          {showPlayer &&

            <>
              {renderVideoPlayer(activeObj)}
            </>
          }
        </div>
      </div> : null}</>
    </div>
  )
}

export default C2wSuperxWinners
